<template>
  <section>
    <img src="/img/bkgrnd.jpg" style="position:absolute;height:100vh;width:100vw;"/>
    <div class="container">
      <div class="spacer"></div>
      <div class="row">
        <card class="col-lg-3 custom"
              hover v-for="event in events">
          <p>{{event.year}}: {{event.tagline}}</p>
          <base-button tag="a" v-bind:href="'/archief/' + event.year" type="primary" class="mt-4">
              Bekijk
          </base-button>
        </card>
    </div>
    </div>
  </section>
</template>

<script>
import ArchiefData from "@/data/ArchiefData.js";
export default {
  data() {
    return {
      events : []
    }
  },
  mounted(){
    ArchiefData.list().then(response => {
      console.log(response);
      this.events = response.data;
    });
  }
}
</script>

<style>
.custom {
  margin: 10px;
  background-color: rgba(255,255,255,.6) !important;
}

.spacer{
    height: 100px;
}
</style>
